import React from 'react'
import { useTranslation } from 'react-i18next'

import { DashboardPageLayout } from '@/components/layouts/dashboard-page-layout'
import { OperationLogV2Screen } from './operation-log-v2-screen'

/** 操作ログ（新）: GET …/operation-log/v2 */
export const OperationLog: React.FC = () => {
  const { t } = useTranslation()
  return (
    <DashboardPageLayout title={t('Operation Log')}>
      <OperationLogV2Screen />
    </DashboardPageLayout>
  )
}
